var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "youtubevideo-container", attrs: { id: _vm.youTubeId } },
    [_c("div", { staticClass: "YouTubeVideo", attrs: { id: _vm.playerId } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }